import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Provider, connect } from 'react-redux';
import { store } from './src/utility';
import {
  withRouter,
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import 'babel-polyfill';
import BrandedTrackingPage from './src/brandedTrackingPage';
import * as logger from '@happyreturns/jscommons';
import DemoTrackingPage from './src/DemoTrackingPage';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {};

  render() {
    return (
      <Router>
        <Switch>
          {/* the expected URLs have only query parameters, if we see one of these
             pass it to the branded tracking page. */}
          <Route exact path="/" component={BrandedTrackingPage} />

          {/* This route renders a page that looks like the branded tracking page,
        but all data is passed in via url params for the purposes of sales team demos.
        Required url params: carrier, tracking, status, departure, estimated-arrival, arrival */}
          <Route path="/demo" component={DemoTrackingPage} />

          {/* if we get an unexpected URL, pass to the tracking page along
             with the error it should show */}
          <Route
            render={(props) => (
              <BrandedTrackingPage {...props} errorMode={true} />
            )}
          />
        </Switch>
      </Router>
    );
  }
}

App = connect(function (state) {
  return {
    fetch: state.fetch,
  };
})(App);

logger.SetLogToConsole(window.ENV === 'local');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app'),
);
